import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'cemo_group',
} as IModuleProps;
